import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../wayfinder'
/**
* @see \App\Http\Controllers\Company\CsmController::update
* @see app/Http/Controllers/Company/CsmController.php:41
* @route '/companies/{company}/csm'
*/
export const update = (args: { company: string | { id: string } } | [company: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

update.definition = {
    methods: ["put"],
    url: '/companies/{company}/csm',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\Company\CsmController::update
* @see app/Http/Controllers/Company/CsmController.php:41
* @route '/companies/{company}/csm'
*/
update.url = (args: { company: string | { id: string } } | [company: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { company: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { company: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            company: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        company: typeof args.company === 'object'
        ? args.company.id
        : args.company,
    }

    return update.definition.url
            .replace('{company}', parsedArgs.company.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Company\CsmController::update
* @see app/Http/Controllers/Company/CsmController.php:41
* @route '/companies/{company}/csm'
*/
update.put = (args: { company: string | { id: string } } | [company: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

const csm = {
    update: Object.assign(update, update),
}

export default csm